module.exports = __webpack_public_path__ + "img/sd.529af6bd.png";